import React from 'react';
import { Card } from 'react-bootstrap';
import './QuizzBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import LexicalViewer from './editor/LexicalViewer';


const ViewArticle = ({content}) => {

  const getDate = () => {
    const date = new Date(content.date);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="py-2 py-md-5">
      <Card className="shadow-lg border-0 border-md">
        <Card.Header className="bg-primary text-white p-3 p-md-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
            <div className="w-100">
              <h2 className="mb-2 fs-4 fs-md-2" style={{ wordBreak: 'break-word' }}>Titre: {content.title}</h2>
              <h6 className="mb-2 text-white-50">
                By: {content.author} 
              </h6>
            </div>
          </div>
        </Card.Header>
        
        <Card.Body className="p-3 p-md-5">
          <div className="article-content" style={{ 
            lineHeight: '1.8',
            fontSize: '1.05rem',
            textAlign: 'left'
          }}>
            <LexicalViewer 
                            content={content.contenu}
                            showCard={false}
                        />
          </div>
        </Card.Body>

        <Card.Footer className="bg-light p-3 p-md-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            {/* <div>
              <strong>Lue:</strong> | {content.lue} fois
            </div> */}
            <div>
              <strong>Partage:</strong> <a target='_blank' rel="noreferrer" href={'https://api.whatsapp.com/send?text=' + window.location.href}><FontAwesomeIcon style={{color: '#128c7e', fontSize: '1.5rem', marginLeft: '5px'}} icon={faWhatsapp} /></a>
            </div>
            <div>
              <strong>Date Publication:</strong> {getDate()}
            </div>
          </div>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default ViewArticle;